/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import { Menu, MenuItem } from "@mui/material";
import React, { useContext, useRef, useState } from "react";
import toast from "react-hot-toast";
import { NavLink, useNavigate } from "react-router-dom";
import avatar from "../../assets/avater.png";
import avatar1 from "../../assets/avatar1.webp";
import avatar2 from "../../assets/avatar2.webp";
import avatar3 from "../../assets/avatar3.webp";
import avatar4 from "../../assets/avatar4.webp";
import avatar5 from "../../assets/avatar5.webp";
import Logo from "../../assets/LogoCBT.png";

import { LogOut } from "lucide-react";
import useUserStore from "../../stores/useUserStores";

//MUI

const DashboardHeader = ({ handleside, side }: any) => {
  const {
    islogin,
    userdetail,
    isAdmin,
    setisAdmin,
    setislogin,
    setToken,
    setuserdetail,
  } = useUserStore();

  let avatars = [avatar, avatar1, avatar2, avatar3, avatar4, avatar5];
  const closeNavbar = () => {
    // document.getElementById("hamburger").checked = false;
  };
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const navigate = useNavigate();
  const handleImageClick = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };
  const handleclick = () => {
    closeNavbar();
    handleImageClick();
  };

  const errornotify = (msg: any) => toast.error(msg);
  const successnotify = (msg: any) => toast.success(msg);

  const logoutuser = async () => {
    // try {
    //   const response = await axios.get(
    //     `${import.meta.env.VITE_APP_BACKEND_URL}/api/v1/users/logout`,
    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       withCredentials: true,
    //     }
    //   );
    //   successnotify(response.data.message);
    //   setTimeout(() => {
    //     window.location.reload();
    //   }, 1500);
    // } catch (error) {
    //   errornotify("Something went wrong!!");
    //   console.error(error.response.data.message);
    // }
  };

  const dropdownRef = useRef(null);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<any>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleNavigate = () => {
    if (
      (!!userdetail && userdetail.userType === "ADMIN") ||
      (!!userdetail && userdetail.userType === "TCADMIN")
    ) {
      navigate("/admin-dashboard/", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  };

  return (
    <>
      <header className="sticky top-0 z-50 bg-neutral-50 backdrop-blur-lg w-full border-b border-gray-200">
        <nav className="relative">
          <div className="flex justify-between items-center w-full px-4 py-3 lg:px-10 mx-auto ">
            {/* Logo */}
            <div className="flex items-center">
              <NavLink to="/" className="flex items-center group">
                <img src={Logo} alt="QCBT Logo" className="h-10 w-auto" />
              </NavLink>
            </div>

            {/* Navigation Actions */}
            <div className="flex items-center gap-4">
              {islogin ? (
                <div className="flex items-center gap-4">
                  <div className="block md:hidden">
                    <LogOut
                      className="text-red-500 text-xs"
                      onClick={() => {
                        setuserdetail(null);
                        setToken("");
                        setislogin(false);
                        setisAdmin(false);
                      }}
                    />
                  </div>
                  {}
                  <div></div>
                  {/* Notification Bell */}
                  {/* <button className="p-2 rounded-full bg-gray-100 border border-gray-200 transition-colors relative">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-gray-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                      />
                    </svg>
                    <span className="absolute top-0.5 right-0.5 h-2 w-2 rounded-full bg-red-500 ring-2 ring-white"></span>
                  </button> */}

                  {/* User Dropdown */}
                  <div className="relative" ref={dropdownRef}>
                    <button
                      onClick={(e) => !!isAdmin && handleClick(e)}
                      className="flex items-center gap-2 focus:outline-none"
                    >
                      <div className="text-right hidden sm:block">
                        <p className="text-sm font-medium text-gray-900">
                          Hi, {userdetail?.fullName || "User"}
                        </p>
                        {/* <p className="text-xs text-gray-500">Premium Member</p> */}
                      </div>
                      <div className="relative md:block hidden">
                        <img
                          src={avatars[0]}
                          alt="Avatar"
                          className="w-10  rounded-full border-2 border-white shadow-md cursor-pointer transition-all"
                        />
                        <span className="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full bg-green-400 ring-2 ring-white"></span>
                      </div>
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex items-center gap-3">
                  <NavLink to="/Login">
                    <button
                      className="px-5 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors hidden sm:block"
                      onClick={() => window.location.reload()}
                    >
                      Sign in
                    </button>
                  </NavLink>
                  <NavLink to="/Signup">
                    <button className="px-5 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-indigo-600 to-indigo-500 rounded-lg shadow-sm hover:shadow-md transition-all hover:from-indigo-500 hover:to-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                      Get started
                    </button>
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default DashboardHeader;
